import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import {
  CmxWebComponentsFormsModule,
  CmxWebComponentsModule
} from '@cmx-web-components/angular';
import { PipesModule } from '../../../../../../pipes/pipes.module';
import { DirectivesModule } from '../../../../../../directives/directives.module';
import {
  CmxDashboardActiveLoadsCardComponent,
  CmxDashboardActiveLoadsCardService
} from './cmx-dashboard-active-loads-card';
import { CmxDashboardDatePickerComponent } from './cmx-dashboard-date-picker/cmx-dashboard-date-picker.component';
import { CmxDashboardJobsiteSelectComponent } from './cmx-dashboard-jobsite-select/cmx-dashboard-jobsite-select.component';
import { CmxDashboardOrderHistoryCardComponent } from './cmx-dashboard-order-history-card';
import { CmxDashboardPaymentsCardComponent } from './cmx-dashboard-payments-card';
import { CmxDashboardTrackCardComponent } from './cmx-dashboard-track-card/cmx-dashboard-track-card.component';
import { CmxInterceptor } from './cmx-interceptor.service';
import { CountlyEvents } from './countly-events.service';
import { DashboardCardComponent } from './dashboard-card/dashboard-card/dashboard-card.component';
import { DonutChartComponent } from './donut-chart/donut-chart.component';
import { ListChartCardComponent } from './list-chart-card';
import { AngularLocalizationModule } from '../../../../../../angular-localization-v7/angular-localization.module';
import { CmxCurrencyPipe } from '../../../../../../angular-localization-v7/pipes/cmx-currency.pipe';

@NgModule({
  declarations: [
    CmxDashboardOrderHistoryCardComponent,
    CmxDashboardTrackCardComponent,
    CmxDashboardPaymentsCardComponent,
    DashboardCardComponent,
    ListChartCardComponent,
    CmxDashboardActiveLoadsCardComponent,
    DonutChartComponent,
    CmxDashboardJobsiteSelectComponent,
    CmxDashboardDatePickerComponent
  ],
  imports: [
    CommonModule,
    CmxWebComponentsModule.forRoot(),
    HttpClientModule,
    CmxWebComponentsFormsModule,
    PipesModule,
    DirectivesModule,
    AngularLocalizationModule
  ],
  exports: [
    CmxDashboardJobsiteSelectComponent,
    CmxDashboardTrackCardComponent,
    CmxDashboardOrderHistoryCardComponent,
    CmxDashboardActiveLoadsCardComponent,
    CmxDashboardPaymentsCardComponent,
    CmxDashboardDatePickerComponent
  ],
  providers: [
    CmxDashboardActiveLoadsCardService,
    CmxCurrencyPipe,
    { provide: HTTP_INTERCEPTORS, useClass: CmxInterceptor, multi: true },
    CountlyEvents
  ]
})
export class CmxDashboardComponentsModule {}
